import { Button } from 'components/button/Button';
import { InputField } from 'components/input/InputField';
import { Formik } from 'components/form/formik';
import toast from 'react-hot-toast';
import { useSWRConfig } from 'swr';
import * as Yup from 'yup';

import { createPackageType, PACKAGE_TYPES_SWR_KEY } from '../models';
import { getDisplayError } from '../../../utils/get-display-error';
import { captureException } from '@sentry/react';

const createPackageTypeSchema = Yup.object().shape({
  id: Yup.string().required('Vereist'),
  nameNl: Yup.string().required('Vereist'),
  nameFr: Yup.string().required('Vereist'),
  nameEn: Yup.string().required('Vereist'),
  nameDe: Yup.string().required('Vereist'),
});

interface IPackageTypeValues {
  id: string;
  nameNl: string;
  nameFr: string;
  nameEn: string;
  nameDe: string;
}

const initialValues: IPackageTypeValues = {
  id: '',
  nameNl: '',
  nameFr: '',
  nameEn: '',
  nameDe: '',
};

interface ICreatePackageTypeFormProps {
  onComplete?: (value: IPackageTypeValues) => void;
  onCancel?: () => void;
}

export const CreatePackageTypeForm: React.FC<ICreatePackageTypeFormProps> = (props) => {
  const { onComplete, onCancel } = props;
  const { mutate } = useSWRConfig();

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={createPackageTypeSchema}
      onSubmit={async (values) => {
        try {
          await createPackageType(values);
          await mutate(PACKAGE_TYPES_SWR_KEY);
          onComplete?.(values);
          toast.success('Verpakking type aangemaakt');
        } catch (err: any) {
          captureException(err);
          toast.error('Kon verpakking type niet aanmaken: ' + getDisplayError(err));
        }
      }}
    >
      {({ handleSubmit, isSubmitting, errors, submitForm }) => {
        return (
          <form onSubmit={handleSubmit}>
            <InputField labelText="Code" type="text" name="id" />
            <InputField labelText="Naam NL" type="text" name="nameNl" />
            <InputField labelText="Naam EN" type="text" name="nameEn" />
            <InputField labelText="Naam FR" type="text" name="nameFr" />
            <InputField labelText="Naam DE" type="text" name="nameDe" />

            <div className="flex justify-between">
              {onCancel && (
                <div>
                  <Button isDisabled={isSubmitting} isLoading={isSubmitting} onTrigger={onCancel}>
                    Annuleer
                  </Button>
                </div>
              )}
              <Button
                type="submit"
                color="primary"
                isDisabled={isSubmitting}
                isLoading={isSubmitting}
                onTrigger={submitForm}
              >
                Maak verpakking type aan
              </Button>
            </div>
          </form>
        );
      }}
    </Formik>
  );
};
